import React from "react";
import ajax from "./../lib/ajax.js";
import moment from 'moment';
import context from "./../lib/context.js";

export default class TaxDocs extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            docs: null,
            country: "",
            isElementVisible: []
        }
        this.getTaxDocsItems = this.getTaxDocsItems.bind(this);
        this.toggleVisibility = this.toggleVisibility.bind(this);
        this.onTaxDocDetailClick = this.onTaxDocDetailClick.bind(this);
    }
    componentDidMount() {
        let self = this;
        ajax.vm()
            .get('people/get-tax-documents/')
            .then(function (res) {
                const result = res.data;
                console.log(result);
                context.message({
                    show: false,
                });
                self.setState({
                    docs: result ? result.taxDocuments : null,
                    country: result ? result.country : ""
                });
            })
            .catch(function (e) {
                console.log(e);
                context.message({
                    show: true,
                    type: "error",
                    message: e,
                    buttons: "close"
                });
            });
    }
    toggleVisibility(index) {
        let isElementVisible = this.state.isElementVisible.slice(0);
        isElementVisible[index] = !isElementVisible[index];
        this.setState({ isElementVisible });
    }
    getTaxDocsItems() {
        let docList = this.state.docs;
        let country = this.state.country.toUpperCase();
        if (docList === null) {
            if (country == "CAN") {
                return (
                    <div className="col-md-12 ap-taxdoc-grid-empty ">
                        You have opted out of paper tax statements.<br></br><br></br>
                        Please note that your annual tax statements will be posted at end of February.<br></br><br></br>
                        <div className="text-danger"><em><strong>Currently no tax documents are available for you to download.<br></br><br></br>
                            As soon as any tax statement is posted, you will receive an email notification</strong></em>.<br></br><br></br></div>
                        When tax documents get posted as PDF, you will be able to view, save, and print.  You may need to download the free Adobe Acrobat Reader.<br></br><br></br>
                        If you have any issues, please contact Alyssa Switzer <a href="mailto: aswitzer@appleone.com" >aswitzer@appleone.com</a>.
                    </div>
                );
            } else if (country == "GBR") {
                return (
                    <div className="col-md-12 ap-taxdoc-grid-empty ">
                        You have opted out of paper tax statements.<br></br><br></br>
                        Please note that your annual tax statements will be posted after the 5th of April. <br></br><br></br>
                        <div className="text-danger"><em><strong>Currently no tax documents are available for you to download.<br></br><br></br>
                            As soon as any tax statement is posted, you will receive an email notification</strong></em>.<br></br><br></br></div>
                        When tax documents get posted as PDF, you will be able to view, save, and print.  You may need to download the free Adobe Acrobat Reader.<br></br><br></br>
                        If you have any issues, please email <a href="mailto: W2@ain1.com" > W2@ain1.com</a>.
                    </div>
                );
            } else {
                return (
                    <div className="col-md-12 ap-taxdoc-grid-empty ">
                        You have opted out of paper tax statements.<br></br><br></br>
                        Please note that your annual tax statements will be posted at the end of January.<br></br><br></br>
                        <div className="text-danger"><em><strong>Currently no tax documents are available for you to download.<br></br><br></br>
                            As soon as any tax statement is posted, you will receive an email notification</strong></em>.<br></br><br></br></div>
                        When tax documents get posted as PDF, you will be able to view, save, and print.  You may need to download the free Adobe Acrobat Reader.<br></br><br></br>
                        If you have any issues, please contact W2 email inbox or email <a href="mailto: W2@ain1.com" > W2@ain1.com</a>.
                    </div>
                );
            }
        }
        let result = [];
        Object.keys(docList).reverse().forEach((key, i) => {
            result.push(
                <div className="row ap-taxdoc-grid-item" key={`year_${key}`}>
                    <div className="col-md-12 ap-taxdoc-col-year">
                        <span onClick={() => this.toggleVisibility(i)} className={this.state.isElementVisible[i] ? "fa fa-caret-down ap-pointer" : "fa fa-caret-right ap-pointer"}></span> <span>{key}</span>
                    </div>
                    {this.state.isElementVisible[i] ?
                        docList[key].map(item => <div className="col-md-12 ap-taxdoc-col-detail" key={`doc_${item.id}`}><span>{item.taxDocName}</span>&nbsp;&nbsp;<a href="#" onClick={() => this.onTaxDocDetailClick(item.id)}>{item.taxDocNameDesc}</a></div>) : null
                    }
                </div>
            )
        });
        if (country == "CAN") {
            return (<div className="container-fluid">
                <div className="ap-taxdoc-grid-header ">
                    You have opted out of paper tax statements.<br></br>
                    Please note that your annual tax statements will be posted at the end of February.<br></br>
                    Current documents listed below and future ones will be posted below (as PDF), they can be viewed, saved, and printed.  You may need to download the free Adobe Acrobat Reader.<br></br>
                    If you have any issues, please contact Alyssa Switzer at <a href="mailto: aswitzer@appleone.com" >aswitzer@appleone.com</a>.
                </div>
                <div className="ap-taxdoc-grid container-fluid">
                    {result}
                </div>
            </div>);
        } else if (country == "GBR") {
            return (<div className="container-fluid">
                <div className="ap-taxdoc-grid-header ">
                    You have opted out of paper tax statements.<br></br>
                    Please note that your annual tax statements will be posted after the 5th of April.<br></br>
                    Current documents listed below and future ones will be posted below (as PDF), they can be viewed, saved, and printed.  You may need to download the free Adobe Acrobat Reader.<br></br>
                    If you have any issues, please email <a href="mailto: W2@ain1.com" > W2@ain1.com</a>.
                </div>
                <div className="ap-taxdoc-grid container-fluid">
                    {result}
                </div>
            </div>);
        } else {
            return (<div className="container-fluid">
                <div className="ap-taxdoc-grid-header ">
                    You have opted out of paper tax statements.<br/>
                    Please note that your annual tax statements will be posted at the end of January.<br/>
                    Current documents listed below and future ones will be posted below (as PDF), they can be viewed, saved, and printed.  You may need to download the free Adobe Acrobat Reader.<br/><br/>
                    If you have any issues, please contact W2 email inbox or email <a href="mailto: W2@ain1.com" >W2@ain1.com</a>.
                </div>
                <div className="ap-taxdoc-grid container-fluid">
                    {result}
                </div>
            </div>);
        }
    }
    onTaxDocDetailClick(id) {
        let url = context.routeUrl(`api/get-taxdoc-detail/` + id);
        let win = window.open(url, "_blank");
    }
    render() {
        const docList = this.getTaxDocsItems();
        return (
            <div className="container">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <h2 className="text-center ap-title">Tax / Miscellaneous Documents</h2>
                            <h3 className="text-center ap-sub-title hide">View Tax Documents</h3>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            {docList}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}